import React from 'react';
import { Router } from 'react-router-dom';
import history from './../services/history';
import CustomRoutes from './../routes';
function App() {
  return (
    <Router history={history}>
      <CustomRoutes />
    </Router>
  );
}
export default App;